<template>
  <div>
    <apexchart ref="chart" type="bar" height="350" :options="chartOptions" :series="series" />
    <p><strong>Category: </strong></p>
    <FilterCategory ref="filter" @select="updateData"></FilterCategory>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts"
import { getActivitiesCounts, getFilterData, topTenActivities } from "../databaseRequests"
import { removeAccents } from "../generalFunctions"
import { mixPalette } from "../generalFunctions"
import FilterCategory from "./FilterCategory"
import { eventBus } from "../App"

// variables and constants definition
const categoriesDataInitial = getActivitiesCounts()
const categoriesNamesInitial = topTenActivities
var categoriesData = categoriesDataInitial
var categoriesNames = categoriesNamesInitial
var colors = mixPalette
var filterArray = []
var filterArray2 = []
var queryFilter = "categoryQuery"
var fieldData = "Facts.count"
var fieldLabel = "Activity.activity"
var fieldFilter = "Activity.category"

export default {
  name: "ColumnActivities",
  components: {
    FilterCategory,
    apexchart: VueApexCharts
  },
  data: function() {
    return {
      series: [
        {
          name: "Companies",
          data: categoriesData
        }
      ],
      labels: categoriesNames,
      chartOptions: {
        labels: categoriesNames,
        chart: {
          height: 350,
          type: "bar",
          events: {
            click: function(chart, w, e) {
              console.log(chart, w, e)
            }
          }
        },
        colors: colors,
        plotOptions: {
          bar: {
            columnWidth: "50%",
            distributed: true
          }
        },
        dataLabels: {
          enabled: false
        },

        xaxis: {
          categories: categoriesNames,
          labels: {
            style: {
              colors: colors,
              fontSize: "14px"
            }
          }
        }
      }
    }
  },
  methods: {
    updateData: function(selectedOption) {
      console.log("in")
      if (selectedOption !== "Select an Option") {
        // if unique company selection is desired remove the comment bars below
        // filterArray = []
        // filterArray2 = []
        var checkOption = false
        /*        for (var i = 0; i < filterArray2.length; i++) {
          if (selectedOption === filterArray2[i]) {
            checkOption = true
          }
        }*/
        var chart = this.$ref.chart
        if (!checkOption) {
          var name =
            queryFilter +
            "_" +
            fieldFilter +
            "_" +
            removeAccents(selectedOption).replace(/[.,#!$%^&*;:{}=\-_`~() ]/g, "")
          categoriesData = getFilterData(name, filterArray, fieldData)
          categoriesNames = getFilterData(name, filterArray2, fieldLabel)
          var db = window.indexedDB.open("ioScience", window.version)
          db.onsuccess = function(event) {
            var tx = event.target.result.transaction("queries", "readwrite")
            var objectStore = tx.objectStore("queries")
            var query = objectStore.get(name)
            query.onsuccess = function() {
              chart.updateSeries(filterArray)
              chart.updateOptions({ labels: filterArray2 })
            }
          }
        }
      } else {
        filterArray = []
        filterArray2 = []
        this.$refs.chart.updateSeries(categoriesDataInitial)
        this.$refs.chart.updateOptions({ labels: categoriesNamesInitial })
      }
      console.log(filterArray, filterArray2)
    }
  },
  beforeMount: function() {
    eventBus.$on("selectedOption", this.updateData)
  }
}
</script>

<style scoped></style>
